export default {
  title: 'Utwórz link rejestracyjny',
  steps: {
    select_gateway: 'Wybierz bramkę',
    copy_link: 'Kopiuj link',
  },
  select_gateway: {
    description: 'Wybierz bramkę płatności, dla której chcesz wygenerować długoterminowy link rejestracyjny.',
  },
  link: {
    proxy_url_label: 'URL rejestracyjny',
    expires_label: 'Wygasa',
    copy_button: 'Kopiuj URL',
    copied: 'Skopiowano!',
    description:
      'Udostępnij ten URL sprzedawcy. Przekierowuje na stronę rejestracji bramki i jest ważny do daty wygaśnięcia.',
  },
  buttons: {
    next: 'Dalej',
    back: 'Wstecz',
    done: 'Gotowe',
  },
  toasts: {
    create_success: 'Link rejestracyjny został pomyślnie utworzony.',
    create_failed: 'Nie udało się utworzyć linku rejestracyjnego.',
  },
};
